var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgIconExternalLinkSquare = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Icon_-_external-link-square",
    "data-name": "Icon - external-link-square",
    xmlns: "http://www.w3.org/2000/svg",
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "external-link-square",
    d: "M10.714,32H1.286A1.286,1.286,0,0,0,0,33.286v9.429A1.286,1.286,0,0,0,1.286,44h9.429A1.286,1.286,0,0,0,12,42.714V33.286A1.286,1.286,0,0,0,10.714,32Zm.429,10.714a.429.429,0,0,1-.429.429H1.286a.429.429,0,0,1-.429-.429V33.286a.429.429,0,0,1,.429-.429h9.429a.429.429,0,0,1,.429.429ZM2.666,41.183a.321.321,0,0,1,0-.455L7.893,35.5l-.019-.019-2.41.009a.321.321,0,0,1-.321-.321V34.9a.321.321,0,0,1,.321-.321l3.643-.009a.321.321,0,0,1,.321.321l-.009,3.643a.321.321,0,0,1-.321.321H8.83a.321.321,0,0,1-.321-.321l.009-2.41L8.5,36.107,3.272,41.334a.321.321,0,0,1-.455,0l-.152-.152Z",
    transform: "translate(0 -32)",
    fill: "#0078c9"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgIconExternalLinkSquare);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/Icon - external-link-square.bf2a7b055fc010247ec9f59a8f3c63d8.svg";